export class GalleryItemStyle {
  phonePortraitWidth = 'uk-child-width-1-1';
  phoneLandscapeWidth = 'uk-child-width-1-2@s';
  tabletLandscapeWidth = 'uk-child-width-1-3@m';
  desktopWidth = 'uk-child-width-1-3@l';
  largeScreensWidth = '';
  maxWidth = '';
  height = '';

  static normalize(styles: Partial<GalleryItemStyle>): GalleryItemStyle {
    const pureStyles = new GalleryItemStyle();

    pureStyles.phonePortraitWidth = styles.phonePortraitWidth ?? pureStyles.phonePortraitWidth;
    pureStyles.phoneLandscapeWidth = styles.phoneLandscapeWidth ?? pureStyles.phoneLandscapeWidth;
    pureStyles.tabletLandscapeWidth = styles.tabletLandscapeWidth ?? pureStyles.tabletLandscapeWidth;
    pureStyles.desktopWidth = styles.desktopWidth ?? pureStyles.desktopWidth;
    pureStyles.largeScreensWidth = styles.largeScreensWidth ?? pureStyles.largeScreensWidth;
    pureStyles.maxWidth = styles.maxWidth ?? pureStyles.maxWidth;
    pureStyles.height = styles.height ?? pureStyles.height;

    return pureStyles;
  }
}
